/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SmtpSettings } from '../../models/smtp-settings';

export interface AppSettingTestEmail$Params {
  emailTo?: string | null;
  emailMessage?: string | null;
      body: SmtpSettings
}

export function appSettingTestEmail(http: HttpClient, rootUrl: string, params: AppSettingTestEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, appSettingTestEmail.PATH, 'post');
  if (params) {
    rb.query('emailTo', params.emailTo, {});
    rb.query('emailMessage', params.emailMessage, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

appSettingTestEmail.PATH = '/applicationsetting/testEmail';
